import React, {Component} from 'react'
import {CadCard} from './card'
import $ from 'jquery'
import {pageLabel} from '../vendor-orders/table/page-label'
import {moreResults} from '../vendor-orders/table/more-results'
import {bestSellersModal} from '../best-sellers/modal'
import {cadBuyerReviewsModal} from '../cad-buyer-reviews/modal'
import FullscreenImage from '../share-property/fullscreen-image'
import LaFashionTable from './la-fashion-table'

const getImageUrl = (cad) => {
  let s3BucketName = cad.o == 't' ? process.env.REACT_APP_OLD_S3_BUCKET_NAME : process.env.REACT_APP_S3_BUCKET_NAME
  if (cad.f == null) {
    return 'https://s3.amazonaws.com/ihlgroup-app-production/logo_new.png'
  } else {
    return 'https://s3.amazonaws.com/' + s3BucketName + '/cad/' + cad.f
  }
}

class CadCards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      layout: 'desktop',
      bestSellersModalOpen: false,
      buyerReviewsModalOpen: false,
      fullscreenCad: {},
      laFashionCad: {},
      laFashionTableOpen: false
    }

    this.resize = this.resize.bind(this)
  }

  componentDidMount() {
    this.resize()
    window.addEventListener('resize', this.resize)
    window.addEventListener('openBestSellersModalEvent', this.openBestSellersModal)
    window.addEventListener('openBuyerReviewsModalEvent', this.openBuyerReviewsModal)
    $(document).keyup(this.arrowKeyboardClick)
    window.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement === null) {
        $('#cad-card-'+this.state.fullscreenCad.i)[0].scrollIntoView()
      }
    })

  }

  componentWillUnmount() {
    $(document).off('keyup')
    window.removeEventListener('resize', this.resize)
    window.removeEventListener('openBestSellersModalEvent', this.openBestSellersModal)
    window.removeEventListener('openBuyerReviewsModalEvent', this.openBuyerReviewsModal)
  }

  arrowKeyboardClick = (e) => {
    if (document.getElementById('fullscreen-image').checkVisibility()) {
      let index = this.props.cads.indexOf(this.state.fullscreenCad)
      if (e.keyCode == '37' && index > 0) {
        index -= 1
      } else if (e.keyCode == '39' && index < this.props.cads.length - 1) {
        index += 1
      }
      this.setState({fullscreenCad: this.props.cads[index]})
    }
  }

  resize() {
    let width = $(window).width()
    let layout = width < 1200 ? 'tablet' : 'desktop'
    this.setState({layout})
  }

  openBestSellersModal = () => this.setState({bestSellersModalOpen: true})
  closeBestSellersModal = () => this.setState({bestSellersModalOpen: false})
  openBuyerReviewsModal = () => this.setState({buyerReviewsModalOpen: true})
  closeBuyerReviewsModal = () => this.setState({buyerReviewsModalOpen: false})

  imageClick = (cad) => {
    this.setState({fullscreenCad: cad})
    document.getElementById('fullscreen-image').requestFullscreen()
  }

  laFashionTableClick = (cad) => {
    this.setState({laFashionCad: cad, laFashionTableOpen: true})
  }

  laFashionTableClose = () => {
    this.setState({laFashionTableOpen: false})
  }

  render() {
    let {sliceNum, loadMore, shippedData, vendorOrders, receivedContainers, inventoryAdjustments, salesOrderData, estimates, contact, contactOptions, status, atsRep, ticketInfo, poeInfo, showFields,
    fromDate, toDate, cadIds, checkboxOnChange, expandAll, laFashionCombine, correctPin, orgId} = this.props
    let {layout, bestSellersModalOpen, buyerReviewsModalOpen, laFashionCad, laFashionTableOpen} = this.state
    let cads = this.props.cads.slice(0, sliceNum)
    let numResults = this.props.cads.length

    return (
      <React.Fragment>
        {bestSellersModal(bestSellersModalOpen, this.closeBestSellersModal, window.bestSellersCad, contactOptions)}
        {cadBuyerReviewsModal(buyerReviewsModalOpen, this.closeBuyerReviewsModal, window.buyerReviewsCad, contactOptions)}
        <FullscreenImage
          src={getImageUrl(this.state.fullscreenCad)}
          address={this.state.fullscreenCad.s}
          showing={(this.props.cads.indexOf(this.state.fullscreenCad)+1)+'/'+(numResults)}
        />

        {
          laFashionCombine && laFashionTableOpen
          ?
          <LaFashionTable cad={laFashionCad} open={laFashionTableOpen} onClose={this.laFashionTableClose}/>
          :
          null
        }

        <div className={"ui stackable cards " + (layout == 'desktop' ? 'four' : 'three')} style={{marginTop: '3px'}}>
          {cads.map((cad, index) => {
            let styles = cad.cads == null ? [cad.s] : cad.cads.map(x => x.s)
            let shipped = styles.reduce((rows, style) => rows.concat(shippedData[style] || []), [])

            let printCard = (
              <CadCard key={index} index={index} cad={cad}
                markCadAsDeleted={this.props.markCadAsDeleted}
                shippedData={shipped} salesOrderDataByStyleNumber={salesOrderData[cad.s]} salesOrderDataById={salesOrderData[cad.i]}
                estimates={estimates == null ? [] : estimates[cad.s]}
                vendorOrders={vendorOrders == null ? [] : vendorOrders.filter(x => x.style_number == cad.s)}
                receivedContainers={receivedContainers == null ? [] : (receivedContainers[cad.s] || [])}
                inventoryAdjustments={inventoryAdjustments == null ? [] : (inventoryAdjustments[cad.s] || [])}
                imageClick={this.imageClick} contact={contact} status={status} atsRep={atsRep} ticketInfo={ticketInfo} poeInfo={poeInfo} showFields={showFields}
                fromDate={fromDate} toDate={toDate} cadIds={cadIds} checkboxOnChange={checkboxOnChange}
                expandAll={expandAll} laFashionCombine={laFashionCombine} correctPin={correctPin}
                laFashionTableClick={this.laFashionTableClick.bind(null, cad)}
                orgId={orgId}/>
            )
            return pageLabel(index, printCard)
          })}
        </div>
        {moreResults(sliceNum, numResults, loadMore)}
      </React.Fragment>
    )
  }
}

export default CadCards
